module.exports = __webpack_public_path__ + "img/icon-change-password.87208fa5.svg";